import {Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  Command,
  CommandStore, showRequestErrors,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { Store } from '@softline/core';
import { Router, RouterModule } from '@angular/router';
import {SOFTLINE_FEATURE_WORK_NOTE_KZWETTER, WorkNoteKzWetterStore} from '../arbeitsschein.shared';
import {ArbeitsscheinConfig, SOFTLINE_CONFIG_ARBEITSSCHEIN} from '../arbeitsschein.config';

const ARBEITSSCHEIN_BEAN_ID = 'Softline.Objekt.StammTables.Arbeitsschein';

@Component({
    selector: 'lib-work-note',
    templateUrl: './work-note.component.html',
    styleUrls: ['./work-note.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule]
})
export class WorkNoteComponent implements OnInit, OnDestroy {
  constructor(
    private store: Store,
    @Inject(SOFTLINE_CONFIG_ARBEITSSCHEIN) private config: ArbeitsscheinConfig,
    protected router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#WORK_NOTE.TITLE'
    );

    const commands = this.createCommands();

    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.addSet,
      { name: WorkNoteComponent, commands }
    );

    if (!this.config || this.config?.hideWeatherSection === false) {
      try {

        await this.store.dispatch(
          SOFTLINE_FEATURE_WORK_NOTE_KZWETTER,
          WorkNoteKzWetterStore.actions.loadOptions,
          { beanIdentifier: ARBEITSSCHEIN_BEAN_ID }
        )
      } catch (e) {
        showRequestErrors(this.store, e)
      }
    }
  }

  ngOnDestroy() {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      ''
    );
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      ''
    );
    this.store.commit(
      SOFTLINE_FEATURE_COMMANDS,
      CommandStore.mutations.removeSet,
      WorkNoteComponent
    );
  }

  protected createCommands(): Command[] {
    return [
      {
        icon: 'fa-regular fa-calendar-check',
        name: '#WORK_NOTE.MENU.LIST',
        class: 'menu main-menu main-menu-top',
        routerLink: ['/arbeitsschein'],
      },
      {
        icon: 'fa-regular fa-magnifying-glass',
        name: '#WORK_NOTE.MENU.QUERY',
        class: 'menu main-menu main-menu-top',
        routerLink: ['arbeitsschein', 'query'],
      },
    ];
  }
}
